import { getLocaleFile as i } from "../../services/translation/index.js";
import { useTranslationContext as s } from "../../contexts/TranslationProvider/context.js";
function m(...n) {
  const { locale: a } = s();
  let o = {};
  return n.forEach((e) => {
    const r = i(
      a,
      e
    );
    o = { ...o, ...r };
  }), { t: (e, ...r) => {
    let t = o[e];
    return t ? (r.forEach((l, c) => {
      t = t.replace(`{${c}}`, l);
    }), t) : "";
  } };
}
export {
  m as useTranslation
};
